import React, { useState, useEffect, Fragment } from "react";
import { ProductsStyled } from "../styled";
import { API_URL } from "../../../utils/Constants";
import {
  CustomBreadcrumb,
  CustomTableFooter,
  MainPageLoader,
  DeleteProductItem,
  CustomModal,
  DELETE_ITEM_TYPES, 
  CUSTOM_MODAL_TYPES
} from "../../../components";
import { MARKETPLACE_CONSTANTS, PRODUCT_HEADERS } from "../../../config/constants";
import { getMerchantId, isSessionExpired } from "../../../utils/Helper";
import { ApiService } from "../../../utils/ApiService";
import { ROUTES } from "../../../config/routes";
import { useNavigate } from "react-router-dom";
import CateogoryAGgrid from "../categories/CateogoryAGgrid";

const Categories = (props) => {
  const [categories, setCategories] = useState([]);
  const [loader, setLoader] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [failureMsg, setFailureMsg] = useState("");
  const navigate = useNavigate();
  const merchantId = getMerchantId();
  useEffect(() => {
    refreshProductCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    !loader && refreshProductCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize]);


  const refreshProductCategoryList = async () => {
    setLoader(true);
    try {
      const url =
        API_URL.PRODUCT_CATEGORIES + "?merchantId=" + merchantId + "&pageNumber=" + pageNo + "&pageSize=" + pageSize;
      const response = await ApiService.getRequest(url, PRODUCT_HEADERS);
      if (isSessionExpired(response)) {
        navigate(ROUTES.LOGIN);
        return;
      }
      if (response?.status?.code === "Y") {
        let categories = response?.body || [];
        setCategories(categories);
        if (categories.length > 0) setLoader(false);
        setTotalCount(parseInt(response?.body?.totalItems || 0));
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const onPageSizeChanged = (event) => setPageSize(event?.target?.value);

  const onLeftArrow = () => setPageNo(pageNo - 1);

  const onRightArrow = () => setPageNo(pageNo + 1);

  const handleNewCategory = () => {
    navigate(`${ROUTES.CATEGORIES}/new`);
  };

  const handleDeleteCategory = (category) => {
    setDeleteCategory(category);
    setShowDelete(true);
  };

  const onConfirmDelete = async () => {
    if (!deleteCategory) return;
    
    try {
      const response = await ApiService.deleteRequest(
        `${API_URL.PRODUCT_CATEGORY}/${deleteCategory.name}`,
        "",
        PRODUCT_HEADERS
      );

      if (response?.status?.code === "Y") {
        setSuccessMsg(response?.status?.message || "Category deleted successfully");
        refreshProductCategoryList();
      } else {
        setFailureMsg(response?.status?.message || "Failed to delete category");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      setFailureMsg("Failed to delete category. Please try again.");
    }
    setShowDelete(false);
    setDeleteCategory(null);
  };

  const onHideDelete = () => {
    setShowDelete(false);
    setDeleteCategory(null);
  };

  return (
    <ProductsStyled>
      <CustomBreadcrumb
        isFromMarketplace={true}
        isFromLandingPage={true}
        header={MARKETPLACE_CONSTANTS.CATEGORIES}
        currentPage={MARKETPLACE_CONSTANTS.CATEGORIES}
        isCreateUser={true}
        onCreateUser={handleNewCategory}
      >
        <div className="welcome-page-container">
          {loader ? (
            <MainPageLoader />
          ) : (
            <Fragment>
              <CateogoryAGgrid 
                categories={categories} 
                onDeleteCategory={handleDeleteCategory}
                {...props} 
              />
              <div className="table-footer-container">
                <CustomTableFooter
                  // Offset logic: pageNo - 1 is used to convert 1-based page numbers to 0-based indices.
                  pageNo={Math.max(pageNo - 1, 0)}
                  pageSize={pageSize}
                  totalCount={totalCount}
                  onPageSizeChanged={onPageSizeChanged}
                  onLeftArrow={onLeftArrow}
                  onRightArrow={onRightArrow}
                />
              </div>
            </Fragment>
          )}
        </div>
      </CustomBreadcrumb>

      {/* Delete Confirmation Modal */}
      <DeleteProductItem
        show={showDelete}
        onHide={onHideDelete}
        description={deleteCategory?.labelEn || deleteCategory?.name}
        type={DELETE_ITEM_TYPES.CATEGORY || "CATEGORY"}
        onDone={onConfirmDelete}
      />

      {/* Success/Failure Modal */}
      <CustomModal
        show={!!successMsg || !!failureMsg}
        modalType={
          failureMsg ? CUSTOM_MODAL_TYPES.FAILURE : CUSTOM_MODAL_TYPES.SUCCESS
        }
        onHide={() => {
          setSuccessMsg("");
          setFailureMsg("");
        }}
        title={failureMsg || successMsg}
        message=""
      />
    </ProductsStyled>
  );
};

export default Categories;
